import { INCOTERM_OPTIONS } from '@klear/constants/options'
import { EventFieldGrid } from '@klear/order-event-ui/event-forms/event-field-grid'
import { dateFormatted, type DateDisplayInput } from '@klear/order-event/list-display'
import {
  EventCombobox,
  EventDatePicker,
  EventFileInput,
  EventDocumentList,
  EventInput,
  EventMoneyInput,
  EventTextarea
} from '@klear/order-event-ui/event-shared/event-form-control'
import { Money } from '@klear/money'

export function PurchaseOrderForm() {
  const incotermOptions = [...INCOTERM_OPTIONS]

  return (
    <>
      <EventFileInput label="Upload File(s)" name="files" multiple />
      <EventDocumentList />
      <div className="grid grid-cols-2 gap-4">
        <EventInput label="PO Number" name="number" />
        <EventCombobox label="Incoterm" name="incoterm" options={incotermOptions} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <EventMoneyInput name="amount" label="Amount" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <EventDatePicker label="Issue Date" name="effectiveDate" />
        <EventDatePicker label="Target Delivery Date" name="endDate" />
      </div>
      <EventTextarea label="Notes" name="notes" />
    </>
  )
}

type PurchaseOrderViewData = {
  number?: string
  incoterm?: string
  effectiveDate: DateDisplayInput
  endDate: DateDisplayInput
  deliveredDate?: DateDisplayInput
  amount: Money
}

export function PurchaseOrderView({ purchaseOrder }: { purchaseOrder: PurchaseOrderViewData }) {
  return (
    <EventFieldGrid
      fields={[
        { label: 'PO Number', value: purchaseOrder.number != null ? `${purchaseOrder.number}` : null },
        { label: 'Issue Date', value: dateFormatted(purchaseOrder.effectiveDate) },
        { label: 'Target Delivery Date', value: dateFormatted(purchaseOrder.endDate) },
        { label: 'Delivered', value: dateFormatted(purchaseOrder.deliveredDate) },
        { label: 'Amount', value: new Money(purchaseOrder.amount).toString() },
        { label: 'Incoterm', value: purchaseOrder.incoterm }
      ]}
    />
  )
}
